import React from "react";
import classNames from "classnames";
import { IconList } from "@/components/IconList";
import { SocialNetwork } from "@/types/qr";
import "./PreviewSocialNetworks.scss";

export interface PreviewSocialNetworksProps {
  /** Redes sociales para mostrar */
  networks?: SocialNetwork[];
  /** Variante de estilo predefinida */
  variant?: "business" | "coupon" | "links" | "website";
  /** Clase CSS adicional */
  className?: string;
  /** Props adicionales para IconList */
  [key: string]: any;
}

// Predefined configurations by variant
const VARIANT_CONFIGS = {
  business: {
    center: true,
    compact: false,
  },
  coupon: {
    center: true,
    compact: true,
  },
  links: {
    center: false,
    compact: false,
  },
  website: {
    center: true,
    compact: false,
  },
} as const;

/**
 * Wrapper para IconList con configuraciones predefinidas por contexto de preview
 * Estandariza el uso de redes sociales en diferentes tipos de QR
 */
export function PreviewSocialNetworks({
  networks,
  variant = "business",
  className,
  ...rest
}: PreviewSocialNetworksProps) {
  if (!networks || networks.length === 0) {
    return null;
  }

  const config = VARIANT_CONFIGS[variant];
  const containerClasses = classNames(
    "preview-social-networks",
    `preview-social-networks--${variant}`,
    className
  );

  return (
    <div className={containerClasses}>
      <IconList
        items={networks}
        {...config}
        {...rest}
      />
    </div>
  );
}
